/* eslint import/prefer-default-export: off */

export enum urlsNetlifyFunctions {
  EMAIL = '/.netlify/functions/email',
  JOIN_US = '/.netlify/functions/CPBForm',
}
